import React from 'react'
import { useSelector } from 'react-redux'

import ParticipantsList from './participants-list'
import { translate } from '~/core/translate'
import { getSessionJids, getSessionParticipants } from '~/selectors/session-details'
import { getDialogProps } from '~/selectors/ui'
import Modal from '~/components/common/modal'

const ParticipantsDialog = () => {
  const { id } = useSelector(getDialogProps)
  const jids = useSelector(getSessionJids(id))
  const participantsList = useSelector(getSessionParticipants(id))

  return (
    <Modal
      title={translate('participants_count', {
        participantsCount: participantsList.length
      })}
    >
      <ParticipantsList jids={jids} participantsList={participantsList} tabbable />
    </Modal>
  )
}

export default ParticipantsDialog
